import React, { useState } from 'react';
import InputField from '../../../../component/form/FormInput';
import Button from '../../../../component/ui/Button';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { formatErrors } from '../../../../utils/controller';
import { createProductCategory } from '../../../../services/products';

const ProductCatogery = ({
	isOpen,
	onCLose,
	reloadTable,
	setAutoFocus,
	setPersistCatogery,
	handleCatogery,
}) => {
	const dispatch = useDispatch();
	const [name, setName] = useState('');
	const [error, setError] = useState('');
	const [loader, setLoader] = useState(false);

	const submitForm = async (event) => {
		event.preventDefault();
		if (name !== '' && name !== undefined && name !== null) {
			try {
				setLoader(true);
				let body = {
					name: name,
				};
				const res = await createProductCategory(body);
				if (res?.success) {
					setPersistCatogery(name);
					setAutoFocus({
						catogrey: false,
						product: true,
						shelf: false,
						tax1: false,
					});
					reloadTable();
					handleCatogery(res.data.category_id);
					toast.success(res?.message);
					onCLose();
				} else {
					formatErrors(res?.data?.message);
					toast.error(res?.data?.message);
				}
			} catch (error) {
				toast.error(error?.response.data?.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		} else {
			setError('Please enter name of category in the field');
		}
	};

	const changeName = (val) => {
		setName(val);

		if (val !== null && val !== '' && val !== undefined) {
			setError('');
		} else {
			setError('Please enter name of shelf in the field');
		}
	};

	return (
		<div>
			<form
				onSubmit={submitForm}
				className="add-productgroup-form"
			>
				<InputField
					label="Category Name"
					placeholder=""
					type="text"
					required={true}
					name="Enter Category Name"
					autoFocus={true}
					onChange={(val) => changeName(val)}
					value={name}
					error={error}
				/>
				<div className="add-productgroup-footer">
					<Button
						onClick={submitForm}
						button="Save"
						className="btn-primary add-pgroup"
						loader={loader}
					/>
					<Button
						type="button"
						button="Cancel"
						className="btn-dark add-pgroup"
						onClick={onCLose}
					/>
				</div>
			</form>
		</div>
	);
};

export default ProductCatogery;
